import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const GenericError = () => (
  <Box p={4} m={2} align='center' color='common.white' bgcolor='error.dark'>
    <Typography variant='h4'>Something went wrong.</Typography>
  </Box>
)

export default GenericError
